import * as utils from '../functions/utils';

export interface IApiCreditCardInput {
  number?: string;
  month?: number;
  year?: number;
  ccv?: string;
}

export default class creditCard {
  Number: string;
  Month: number;
  Year: number;
  CCV: string;

  constructor() {
    this.Number = '';
    this.Month = -1;
    this.Year = -1;
    this.CCV = '';
  }

  static mappingPropertyObject(_obj: IApiCreditCardInput): creditCard {
    let obj = new creditCard();
    obj.Number = _obj.number || '';
    obj.Month = _obj.month || -1;
    obj.Year = _obj.year || -1;
    obj.CCV = _obj.ccv || '';

    obj = (utils as any).cleanObjectKeys(Object.keys(new creditCard()), obj);

    return obj;
  }
}
